<template>
    <div style="height: 100%;">
        <common-chart class="h-100" :options="otdOperation"></common-chart>
    </div>
</template>

<script>
import {_pxGenerator} from "@/components/LayoutMaps/maps/MapFunction";
import EmCommonApi from "@/mixin/em/common/api";
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart.vue";

export default {
    name: "OTDChart",
    components: {CommonChart},
    mixins: [EmCommonApi],
    data() {
        return {
            chart: {},
            fs: 0.12,
            otdOperation: {},
            //lineName: ["APT-OTD", "Parts-OTD", "APT-OTD-R2", "Parts-OTD-R2", "APT-LT", "Parts-LT"],   //屏蔽LT
            //lineName: ["APT_OTD", "PARTS_OTD", "APT_OTD_R2", "PARTS_OTD_R2"],   //APT备份
            lineName: ["AP_OTD", "T_OTD", "PARTS_OTD", "AP_OTD_R2", "T_OTD_R2", "PARTS_OTD_R2"],   //拆分APT为AP | T
            dates: [],
            data: {
                AP_OTD: [],
                T_OTD: [],
                PARTS_OTD: [],
                AP_OTD_R2: [],
                T_OTD_R2: [],
                PARTS_OTD_R2: [],
            },
            min_otd: 90,
            max_otd: 100,
            min_otd_R2: 90,
            max_otd_R2: 100,
            min_lt: 90,
            max_lt: 100,
            refresh: null,
            otdOpenRules: 1,
            otdSwitchForm: {
                otdOpenRules: 1,
                otdCustomKpiEnable: 0,
                otdRule1LateDays: 0,
                allOtdLineGroup: ''
            }
        };
    },
    mounted() {
        this.getSysParamOTDSwitchRules()
        this.getRemoteData()
        this.refresh = setInterval(() => {
            this.getRemoteData();
        }, 24 * 36000 * 1000);
    },
    beforeDestroy() {
        clearInterval(this.refresh);
    },
    methods: {
        getSysParamOTDSwitchRules() {
            let _this = this;
            const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesMstLocation")}/sithMesMstLocation/kpi/getSysParamOTDSwitchRules`
            this.$_emApiMixin_get(_api, false).then(value => {
                console.log("------------ OTD Open rules --------->>>")
                console.log(value)
                _this.otdSwitchForm.otdOpenRules = parseInt(value.otdOpenRules);
                _this.otdSwitchForm.otdCustomKpiEnable = value.otdCustomKpiEnable === '1' ? true : false;
                _this.otdSwitchForm.otdRule1LateDays = parseInt(value.otdRule1LateDays);
                _this.otdSwitchForm.allOtdLineGroup = value.allOtdLineGroup;
                console.log(_this.otdSwitchForm)
            })
        },
        getRemoteData() {
            let _this = this;
            const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesMstLocation")}/sithMesMstLocation/kpi/otd`
            this.$_emApiMixin_get(_api, false).then(value => {
                console.log("------------ OTD Result --------->>>")
                console.log(value)
                this.handleRemoteValue(value, _this);
            })

        },
        handleRemoteValue: function (value, _this) {
            let otd_max = 0, otd_min = 100;
            let otd_max_r2 = 0, otd_min_r2 = 100;
            //let lt_max = 0, lt_min = 100;
            for (let key in value) {
                let tempList = [];
                let dateList = [];
                if (value.hasOwnProperty(key)) {
                    for (let dateStr in value[key]) {
                        if (value[key].hasOwnProperty(dateStr)) {
                            dateList.push(dateStr);
                            let val = value[key][dateStr];
                            tempList.push(val === 0 ? null : val);
                            if (key.endsWith("OTD")) {
                                if (val > 0) {
                                    if (val > otd_max) {
                                        otd_max = val;
                                    } else if (val < otd_min) {
                                        otd_min = val;
                                    }
                                }
                            } else if (key.endsWith("OTD_R2")) {
                                //规则1和规则2两组合并计算Y轴上下限
                                if (val > 0) {
                                    if (val > otd_max) {
                                        otd_max = val;
                                    } else if (val < otd_min) {
                                        otd_min = val;
                                    }
                                }
                            }
                            // else if (val > lt_max) {
                            //         lt_max = val;
                            //     } else if (val < lt_min) {
                            //         lt_min = val;
                            //     }
                            // }
                        }
                    }
                    _this.data[key] = tempList;
                    _this.dates = dateList;
                }
            }
            _this.max_otd = otd_max < 95 ? this.nextFive(otd_max) : 100;
            _this.min_otd = otd_min > 5 ? this.preFive(otd_min) : 0;
            _this.max_otd_r2 = otd_max_r2 < 95 ? this.nextFive(otd_max_r2) : 100;
            _this.min_otd_r2 = otd_min_r2 > 5 ? this.preFive(otd_min_r2) : 0;
            //_this.max_lt = lt_max < 95 ? this.nextFive(lt_max) : 100;
            //_this.min_lt = lt_min > 5 ? this.preFive(lt_min) : 0;
            
            _this.initData();
        },
        nextFive(val) {
            return Math.ceil((val + 5) / 5) * 5;
        },
        preFive(val) {
            return Math.floor((val - 5) / 5) * 5;
        },
        initData() {
            //处理series
            const seriesMap = {
                0: [0, 1, 2],
                1: [0, 1, 2],
                2: [3, 4, 5],
                3: [0, 1, 2, 3, 4, 5]
            };
            const selectedSeries = seriesMap[this.otdSwitchForm.otdOpenRules];

            const handleSeries = selectedSeries.map((index, i) => ({
                name: this.lineName[index],
                data: this.getDataByIndex(index),
                type: "line",
                lineStyle: {
                    color: this.getLineColor(index)
                },
                itemStyle: {
                    borderWidth: _pxGenerator(0.04),
                    borderColor: this.getLineColor(index),
                    color: this.getLineColor(index)
                }
            }));

            //处理legend样式
            let legendFontSize = _pxGenerator(this.fs) + 5;
            if (this.otdSwitchForm.otdOpenRules === 3) {
                legendFontSize = _pxGenerator(this.fs) + 2;
            }
            this.otdOperation = {
                grid: {
                    bottom: '10%',
                    top: '20%'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: this.lineName,
                    top: 0,
                    textStyle: {
                        color: '#fff',
                        fontSize: legendFontSize,  //2023.7.27 上墙字体小，计算后+5
                    },
                    zLevel: 10,
                    width: '100%'
                },
                xAxis: {
                    data: this.dates,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisLabel: {
                        margin: _pxGenerator(0.04),
                        rotate: 30,
                        fontSize: _pxGenerator(this.fs)
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        name: "OTD/%",
                        nameTextStyle: {
                            fontSize: _pxGenerator(this.fs)
                        },
                        axisLabel: {
                            fontSize: _pxGenerator(this.fs),
                            margin: _pxGenerator(0.02)
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#575665'
                            },
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        min: this.min_otd,
                        max: this.max_otd
                    },
                ],
                series: handleSeries,
            };
        },
        getDataByIndex(index) {
            switch (index) {
                case 0:
                    return this.data.AP_OTD;
                case 1:
                    return this.data.T_OTD;
                case 2:
                    return this.data.PARTS_OTD;
                case 3:
                    return this.data.AP_OTD_R2;
                case 4:
                    return this.data.T_OTD_R2;
                case 5:
                    return this.data.PARTS_OTD_R2;
                default:
                    return [];
            }
        },
        getLineColor(index) {
            switch (index) {
                case 0:
                    return "rgba(0, 186, 255, 0.8)";
                case 1:
                    return "rgba(255, 92, 169, 0.8)";
                case 2:
                    return "rgba(255, 159, 0, 0.8)";
                case 3:
                    return "rgba(0,255,74, 0.8)";
                case 4:
                    return "rgba(155, 35, 215, 0.8)";
                case 5:
                    return "rgba(235, 69, 17, 0.8)";
                default:
                    return "";
            }
        },
    }
};
</script>

<style scoped>
.a {
    color: #ffd632;
}
</style>
